import { cva } from "class-variance-authority"

export const textAreaVariants = cva(
  [
    "rounded-sm border border-red-200 bg-white text-sm text-gray-700 outline-0",
    "hover:border-gray-500",
    "active:border-primary-600 active:bg-gray-50",
    "focus:border-primary-600 focus-visible:border-primary-600 ",
    "disabled:border-red-200 disabled:bg-gray-50 disabled:text-gray-500",
  ],
  {
    variants: {
      size: {
        medium: "h-[80px] text-sm px-4 py-2.5",
        small: "h-[76px] text-xs p-3",
        large: "h-[84px] text-md px-4 py-3",
      },
      invalid: {
        false: null,
        true: [
          "border-red-600",
          "hover:border-red-600 hover:bg-[#FDF8F8]",
          "active:border-red-600 active:bg-red-100",
          "focus:border-2 focus:border-red-600 focus-visible:border-2 focus-visible:border-red-600",
        ],
      },
      border: {
        true: null,
        false: [
          "border-none",
          "hover:bg-gray-50",
          "active:bg-gray-50",
          "focus:bg-[#EDF2FC] focus-visible:bg-[#EDF2FC]",
        ],
      },
    },
    defaultVariants: {
      size: "medium",
      invalid: false,
      border: true,
    },
    compoundVariants: [
      {
        invalid: true,
        border: false,
        className: [
          "bg-red-100",
          "hover:bg-red-50",
          "active:bg-[#F8E2E3]",
          "focus:bg-red-50 focus-visible:bg-red-50",
        ],
      },
    ],
  }
)

export const textAreaLabelVariants = cva(
  [
    "absolute left-3 leading-none top-2 rounded-xs bg-white text-gray-900 transition-all duration-200",
    "peer-active:text-primary-600",
    "peer-focus:-top-2 peer-focus:px-1 peer-focus:text-primary-600",
    "peer-disabled:text-gray-500 peer-disabled:bg-gray-50",
  ],
  {
    variants: {
      size: {
        medium: "text-sm leading-none left-4 top-2.5",
        small: "text-xs leading-none left-3 top-3",
        large: "text-md leading-none left-4 top-3",
      },
      invalid: {
        true: "text-red-600 peer-active:text-red-600 peer-focus:text-red-600",
        false: null,
      },
      border: {
        true: null,
        false: [
          "peer-hover:bg-gray-50",
          "peer-active:bg-gray-50",
          "peer-focus:bg-[#EDF2FC] peer-focus-visible:bg-[#EDF2FC]",
        ],
      },
    },
    defaultVariants: {
      size: "medium",
      invalid: false,
      border: true,
    },
    compoundVariants: [
      {
        invalid: true,
        border: false,
        className: [
          "bg-red-100",
          "peer-hover:bg-red-50",
          "peer-active:bg-[#F8E2E3]",
          "peer-focus:bg-red-50 peer-focus-visible:bg-red-50",
        ],
      },
    ],
  }
)
